import { Repository } from '@frontend-site/shared/utils';
import { UserDetails } from '@frontend-site/shared/data';
import { createStore, select, withProps } from '@ngneat/elf';
import { Injectable } from '@angular/core';
import { AuthState } from './auth-state';

function createInitialState(): AuthState {
    return {
        user: null
    };
}

@Injectable({ providedIn: 'root' })
export class AuthStore extends Repository<AuthState> {
    public readonly user$ = this.store.pipe(select((state) => state.user));

    constructor() {
        super(createStore({ name: 'AuthStore' }, withProps<AuthState>(createInitialState())));
    }

    public setUser(user: UserDetails): void {
        this.update({ user: user });
    }
}
